import { useState } from 'react'
import { downloadPDF } from '../../../../utility/event'

import Modal from '../../../common/Modal'
import PairingsReport from './PairingsReport'
import LeaderboardReport from './LeaderboardReport'
import SubmitButton from '../../../common/buttons/SubmitButton'
import Scorecards from './Scorecards'
import AlphaReport from './AlphaReport'
import CartSigns from './CartSigns'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import classes from './PreviewModal.module.scss'

const PreviewModal = ({ showModal, closeModal, report, event }) => {
  const [loader, setLoader] = useState(false)

  const downloadReport = (type) => {
    setLoader(true)
    downloadPDF(type, event.name).then(() => {
      setLoader(false)
      closeModal()
    })
  }

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      onRequestClose={closeModal}
      contentLabel='Preview Report'
      className={classes.previewModal}
      autoFocus
    >
      <div className={classes.modalTitle}>
        Preview
      </div>
      <div className={classes.modalBody}>
        {report === 'PairingsTeeSheet' && <PairingsReport/>}
        {report === 'PairingsAlphaTeeSheet' && <AlphaReport/>}
        {report === 'ScoreCards' && <Scorecards/>}
        {report === 'Leaderboard' && <LeaderboardReport/>}
        {report === 'CartSigns' && <CartSigns/>}
      </div>

      <div className={classes.modalFooter}>
        <div className={classNames(classes.downloadButton, 'pull-right')}>
          <SubmitButton
            onClick={() => downloadReport(report)}
            buttonMessage={loader ? 'Loading Report' : 'Download Report'}
            buttonColor='orange-button'
            disabled={loader}
            loading={loader}
          />
        </div>
      </div>
    </Modal>
  )
}

PreviewModal.propTypes = {
  showModal: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  report: PropTypes.string,
  event: PropTypes.shape({
    name: PropTypes.string,
  }),
}

export default PreviewModal
